var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuoteLocationPin = function SvgQuoteLocationPin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.22217C16 14.4444 8 19.7777 8 19.7777C8 19.7777 0 14.4444 0 8.22217C3.16163e-08 6.10044 0.842855 4.0656 2.34315 2.56531C3.84344 1.06502 5.87827 0.222168 8 0.222168C10.1217 0.222168 12.1566 1.06502 13.6569 2.56531C15.1571 4.0656 16 6.10044 16 8.22217Z",
    fill: "#0F72E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 10.8889C9.47268 10.8889 10.6666 9.69497 10.6666 8.22221C10.6666 6.74945 9.47268 5.55554 7.99992 5.55554C6.52716 5.55554 5.33325 6.74945 5.33325 8.22221C5.33325 9.69497 6.52716 10.8889 7.99992 10.8889Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuoteLocationPin);
export default ForwardRef;